/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
import router from 'assets/js/common/router/index';
import browser from 'assets/js/modules/browser';
import 'lazysizes';

$(function() {
    //weak clickjacking protection
    if (document.location.hostname == 'farheap.marketing.adobe.com' || document.location.hostname == 'webvisor.com') {
        if (top.location != location) {
            top.location.href = location.href;
        }
    }

    //check for browser
    if (browser.isNotSupported()) {
        var page = '/' + window.location.pathname.split('/').pop();
        if (page != router.generate('/browser-not-supported')) {
            $('.old-browser-warning').removeClass('hidden');
        }
    }
    $('.js-go-back').on('click', function(event) {
        event.preventDefault();
        window.history.back();
    });
});

if (ONP.config.liveAssist.enabled) {
    Promise.all([import('APP_THEME/_common/live_assist/index'), import('assets/js/common/storage/cookie')]).then(
        ([{ default: LiveAssist }, cookie]) => {
            LiveAssist.init(ONP.config.liveAssist.accountNumber, [
                {
                    type: 'ctmrinfo',
                    info: {
                        ctype: ONP.user.vipLevel,
                        customerId: cookie.getItem('userId'),
                        loginStatus: ONP.user.loggedIn,
                        userName: ONP.user.email,
                        visitorName: ONP.user.firstName + ' ' + ONP.user.lastName
                    }
                },
                {
                    type: 'personal',
                    personal: {
                        firstname: ONP.user.firstName,
                        lastname: ONP.user.lastName
                    }
                }
            ]);
        }
    );
}
